
import { ChangeEvent, DataSourceMode, DataSourceModeChangeEvent, DropdownSelectionEvent, Layout, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutBrltlFuelSurchargeProfile } from "./autogen/AutogenLayoutBrltlFuelSurchargeProfile";
import { StringUtil } from "@mcleod/core";

export class BrltlFuelSurchargeProfile extends AutogenLayoutBrltlFuelSurchargeProfile {

    sourceCustomerFuelAfterModeChange(event: DataSourceModeChangeEvent) {
        this.textboxLtlCode.enabled = (event.newMode != DataSourceMode.UPDATE)
        this.determineScreenState();
    }

    switchCalculateUsingOnChange(event: ChangeEvent) {
        this.panelCustomTable.visible = !event.newValue;
        this.panelFormula.visible = event.newValue;
    }

    textboxMethodAfterDropdownSelection(event: DropdownSelectionEvent) {
        const fuelSurchargeMethod: string = event.selection?.value as string;
        if (!StringUtil.isEmptyString(fuelSurchargeMethod)) {
            this.textboxAmount.enabled = (fuelSurchargeMethod === "D");
            this.textboxAmount.required = (fuelSurchargeMethod === "D");
            this.textboxFuelPercent.enabled = (fuelSurchargeMethod !== "D");
            this.textboxFuelPercent.required = (fuelSurchargeMethod !== "D");
            if (fuelSurchargeMethod == "D")
                this.sourceCustomerFuel.activeRow?.set("fuel_percent", null);
            else
                this.sourceCustomerFuel.activeRow?.set("amount", null);
        }
    }

    textboxCustomFscHdrIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.determineScreenState();
    }

    determineScreenState() {
        const haveCustomTableCode: boolean = (null != this.sourceCustomerFuel.activeRow?.get("custom_fsc_hdr_id"));
        this.setFormulaEnabled(haveCustomTableCode);
        this.switchCalculateUsing.checked = this.panelFormula.visible = !haveCustomTableCode;
        this.panelCustomTable.visible = haveCustomTableCode;
    }

    setFormulaEnabled(haveCustomTableCode: boolean) {
        if (haveCustomTableCode) {
            this.sourceCustomerFuel.activeRow?.set("base_price", null);
            this.sourceCustomerFuel.activeRow?.set("fuel_variance", null);
            this.sourceCustomerFuel.activeRow?.set("round_surchg_calc", null);
            this.sourceCustomerFuel.activeRow?.set("method", null);
            this.sourceCustomerFuel.activeRow?.set("amount", null);
            this.sourceCustomerFuel.activeRow?.set("fuel_percent", null);
        }
        this.textboxBasePrice.enabled = !haveCustomTableCode;
        this.textboxBasePrice.required = !haveCustomTableCode;
        this.textboxBasePrice.borderColor = "default.lighter";
        this.textboxFuelVariance.enabled = !haveCustomTableCode;
        this.textboxFuelVariance.required = !haveCustomTableCode;
        this.textboxFuelVariance.borderColor = "default.lighter";
        this.textboxRoundSurchgCalc.enabled = !haveCustomTableCode;
        this.textboxRoundSurchgCalc.required = !haveCustomTableCode;
        this.textboxRoundSurchgCalc.borderColor = "default.lighter";
        this.textboxMethod.enabled = !haveCustomTableCode;
        this.textboxMethod.required = !haveCustomTableCode;
        this.textboxMethod.borderColor = "default.lighter";
        this.textboxAmount.enabled = !haveCustomTableCode;
        this.textboxAmount.required = !haveCustomTableCode;
        this.textboxAmount.borderColor = "default.lighter";
        this.textboxFuelPercent.enabled = !haveCustomTableCode;
        this.textboxFuelPercent.required = !haveCustomTableCode;
        this.textboxFuelPercent.borderColor = "default.lighter";

        if (!haveCustomTableCode && !StringUtil.isEmptyString(this.sourceCustomerFuel.activeRow?.get("method"))) {
            const fuelSurchargeMethod: string = this.sourceCustomerFuel.activeRow?.get("method") as string;
            if (!StringUtil.isEmptyString(fuelSurchargeMethod)) {
                this.textboxAmount.enabled = (fuelSurchargeMethod === "D");
                this.textboxAmount.required = (fuelSurchargeMethod === "D");
                this.textboxFuelPercent.enabled = (fuelSurchargeMethod !== "D");
                this.textboxFuelPercent.required = (fuelSurchargeMethod !== "D");
            }
        }
    }
}
